export default __webpack_public_path__ + "static/media/card-sort-02.b15a0631.JPG";